import { NAVIGATION_TO_LANDING_PAGE } from '../../actions/page';
import {
  RECEIVE_ORDER_DATA_ADDRESSES,
  RECEIVE_SHIPPING_ADDRESS,
  RECEIVE_NOTIFICATION_MESSAGE,
  SET_SHIPPING_ADDRESS_VALIDATION,
  SET_USER_SHIPPING_ADDRESS,
  SET_USER_VALIDATION,
  SET_COLLECT_GIFT_ADDRESS,
  SET_IS_VALID_ADDRESS,
  SET_SHIPPING_ADDRESS_FORM_INVALID,
} from '../../actions/addresses';

export const initialState = {
  shipTo: {},
  billTo: {},
  customerInfo: {},
  shippingAddress: {},
  initialShippingAddressFormValidation: true,
  userShippingAddress: {
    street_1: '',
    street_2: '',
    city: '',
    state: '',
    zip: '',
    country: '',
  },
  defaultAddressKey: '',
  isShippingAddressValid: false,
  notificationMsg: '',
  collectGiftAddress: false,
  isValidAddress: undefined,
  hasInvalidShippingAddressForm: undefined,
};

export default (
  state = initialState,
  {
    type,
    data: {
      shipTo = {},
      billTo = {},
      customerInfo = {},
      shippingAddress = {},
      initialShippingAddressFormValidation = true,
      userShippingAddress = {},
      defaultAddressKey = '',
      isShippingAddressValid = false,
      notificationMsg,
      isValidAddress,
      hasInvalidShippingAddressForm,
    } = {},
  } = {},
) => {
  switch (type) {
    case RECEIVE_ORDER_DATA_ADDRESSES:
      return {
        ...state,
        shipTo,
        billTo,
        customerInfo,
        defaultAddressKey,
      };

    case RECEIVE_SHIPPING_ADDRESS:
      return {
        ...state,
        shippingAddress,
      };

    case SET_SHIPPING_ADDRESS_VALIDATION:
      return {
        ...state,
        isShippingAddressValid,
      };

    case SET_USER_SHIPPING_ADDRESS:
      return {
        ...state,
        userShippingAddress,
      };

    case SET_USER_VALIDATION:
      return {
        ...state,
        initialShippingAddressFormValidation,
      };

    case RECEIVE_NOTIFICATION_MESSAGE:
      return {
        ...state,
        notificationMsg,
      };

    case SET_COLLECT_GIFT_ADDRESS:
      return {
        ...state,
        collectGiftAddress: true,
      };

    case SET_IS_VALID_ADDRESS:
      return {
        ...state,
        isValidAddress,
      };

    case SET_SHIPPING_ADDRESS_FORM_INVALID:
      return {
        ...state,
        hasInvalidShippingAddressForm,
      };

    case NAVIGATION_TO_LANDING_PAGE:
      return { ...initialState };

    default:
      return state;
  }
};
